import Rebase from "re-base";
import firebase from "firebase";


const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyB5jixiM2yT7DevMU-CIkXf10kmzROhnzg",
  authDomain: "catch-of-the-day-prakhars98.firebaseapp.com",
  databaseURL: "https://catch-of-the-day-prakhars98-default-rtdb.firebaseio.com",
});

const base = Rebase.createClass(firebaseApp.database());

export { firebaseApp };
export default base;